import { BaseNetworkActionValidator } from '../base.network.action.validator';
import { ProtectedEntity } from '@nirvana/shared/dtos/types/protected-entities/common';
import { ProtectedEntitiesHelper } from '../../../helpers/protectedEntities/protected.entities.helper';

export class AssignPolicyActionValidator extends BaseNetworkActionValidator {
  protected canRunForUnmanagedCompanies = false;
  protected requiresTasksEnabled = false;

  protected _canPerformAction(record: ProtectedEntity): boolean {
    if (ProtectedEntitiesHelper.isAwsInstance(record) && ProtectedEntitiesHelper.isPowerStateTerminated(record)) {
      return false;
    }

    return true;
  }
}
